// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Menu-cls1___22663e9662ed842bf66{/*!*/}.Menu-cls2___d2ef027d7ae3461f1c3{display:flex;flex-direction:column;align-items:flex-start;flex:1 1;background:#fff;background:var(--background-white, #fff);border-radius:16px;border-radius:var(--radius-corner-radius-default, 16px);border:1px solid #dddde2;border:1px solid var(--stroke-light, #dddde2);overflow:auto;padding:8px 0px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "Menu-cls1___22663e9662ed842bf66",
	"cls2": "Menu-cls2___d2ef027d7ae3461f1c3 Menu-cls1___22663e9662ed842bf66"
};
export default ___CSS_LOADER_EXPORT___;
